module.exports = __webpack_public_path__ + "static/media/icon_level1.edf83571.svg";